import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// Language files
import translationsEN from "./en.json";
import translationsNL from "./nl.json";

i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: "en",
        fallbackLng: "en",
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: translationsEN,
            nl: translationsNL
        }
    });

export default i18n;


// WEBPACK FOOTER //
// ./src/Translations/i18n.ts